import { axios } from '@/utils/request'
import tool from '@/utils/tool'

const baseURL = '/jpaas-jaas-web-server'

// 使用示例
const token = tool.getCookie('accessToken') || ''

const api = {
  isLogin: `${baseURL}/interface/buttjoint/jisbuttsuccess`, // 获取用户信息
  undoList: `${baseURL}/front/apply/undoList`, // 查询我的待办任务接口
  applyList: `${baseURL}/front/apply/applyList`, // 查询我的申请记录
  applyDetail: `${baseURL}/front/apply/applyDetail`, // 查询我的申请记录详情
  remiancount: `${baseURL}/front/reservation/remiancount`, // 预约余量查询
  submitAppointment: `${baseURL}/front/reservation/submit`, // 提交预约信息
  findConfig: `${baseURL}/front/config/find`, // 根据类型获取配置 配置类型 syzy-使用指引；yyxz-预约须知；yhxz-视频帮办用户须知；yhxy-授权代办用户须知；xxpz-消息配置
  filePreview: `${baseURL}/interface/business/file-preview`, // 视频指引文件预览
  findItemList: `${baseURL}/interface/item/findItemList`, // 一件事列表接口
  findSubject: `${baseURL}/interface/item/findSubject`, // 主题列表接口
  findDistrict: `${baseURL}/interface/district/find-district`, // 获取区划
  getLiveId: `${baseURL}/interface/video/get-liveId`, // 获取会议id
  uploadFile: `${baseURL}/interface/business/upload-approve-file`, // 文件上传
  addMaterial: `${baseURL}/interface/material/addMaterial`, // 上传完保存材料接口
  uploadSignurate: `${baseURL}/interface/business/upload-signurate-pic`, // 签名上传接口
  modifyReviewState: `${baseURL}/front/apply/modifyReviewState`, // 修改评价状态
  itemDetail: `${baseURL}/interface/item/detail` // 修改评价状态
}

export const JaasWebApi = {
  isLogin(parameter) {
    return axios({
      url: api.isLogin,
      method: 'get',
      params: parameter,
      headers: {
        'access-token': token || JSON.parse(sessionStorage.getItem('JiopUserInfo'))?.accessToken
      }
    })
  },
  itemDetail(params) {
    return axios({
      url: api.itemDetail,
      method: 'get',
      params
    })
  },
  undoList(params) {
    return axios({
      url: api.undoList,
      method: 'get',
      params
    })
  },
  applyList(params) {
    return axios({
      url: api.applyList,
      method: 'get',
      params
    })
  },
  applyDetail(params) {
    return axios({
      url: api.applyDetail,
      method: 'get',
      params
    })
  },
  remiancount(params) {
    return axios({
      url: api.remiancount,
      method: 'get',
      params
    })
  },
  submitAppointment(data) {
    return axios({
      url: api.submitAppointment,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  findConfig(params) {
    return axios({
      url: api.findConfig,
      method: 'get',
      params
    })
  },
  filePreview(params) {
    return axios({
      url: api.filePreview,
      method: 'get',
      params
    })
  },
  findItemList(params) {
    return axios({
      url: api.findItemList,
      method: 'get',
      params
    })
  },
  findSubject(params) {
    return axios({
      url: api.findSubject,
      method: 'get',
      params
    })
  },
  findDistrict(params) {
    return axios({
      url: api.findDistrict,
      method: 'get',
      params
    })
  },
  getLiveId(params) {
    return axios({
      url: api.getLiveId,
      method: 'get',
      params
    })
  },
  uploadFile(data) {
    return axios({
      url: api.uploadFile,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  addMaterial(data) {
    return axios({
      url: api.addMaterial,
      method: 'post',
      data
    })
  },
  uploadSignurate(data) {
    return axios({
      url: api.uploadSignurate,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  modifyReviewState(data) {
    return axios({
      url: api.modifyReviewState,
      method: 'post',
      data
    })
  }
}
